import {ElementChipList as CommonElementChipList} from "crqlar-react-common/dist/components/uiElements/base/ElementChipList";

export const ElementChipList = CommonElementChipList;
